import React from "react";
import { LuiButton, LuiFormikForm, LuiFormSubmitButton, LuiLoadingSpinner } from "@linzjs/lui";
import { TextInput } from "./Forms"
import { withRouter } from "react-router";
import * as yup from "yup";
import { Auth } from 'aws-amplify';

class RequestFiles extends React.Component {

  static validation = {
    name: yup.object().shape({name: yup.string().required()}),
    email: yup.object().shape({email: yup.string().required().email()})
  }

  constructor(props) {
    super(props);

    this.state = {
      name: "",
      email: "",
      isLoaded: true,
      validationFailed: {
        name: false,
        email: false,
        isLoaded: false
      }
    };

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  async handleInputChange(event) {
    const target = event.target;
    const { validationFailed } = this.state;
    validationFailed[target.name] = !(await RequestFiles.validation[target.name].isValid({[target.name]: target.value}));
    this.setState({
      [target.name]: target.value,
      validationFailed: validationFailed
    })
  }
  
  async handleSubmit() {
    const { name, email, validationFailed } = this.state;
    validationFailed.name = !(await RequestFiles.validation["name"].isValid({"name": name}));
    validationFailed.email = !(await RequestFiles.validation["email"].isValid({"email": email}));
    this.setState({
      validationFailed: validationFailed
    })
    if (validationFailed.name || validationFailed.email) {
      return;
    }
    this.setState({
      isLoaded: false
    });
    const files = this.props.location.state.files;
    const uris = files.map(file => file.URI).join(",");

    const session = await Auth.currentSession();
    const headers = {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + session.accessToken.jwtToken
    };
    const options = {
      method: "POST",
      headers: headers,
      mode: "cors",
      cache: "default",
      body: JSON.stringify({
        "name": name,
        "email": email,
        "uris": uris
      })
    };
    fetch("https://" + process.env.REACT_APP_API_URL + "/email", options)
      .then((response) => {
        if (!response.ok) {
            return Promise.reject(response);
        }
        this.navigateToEmail(false);
      })
      .catch(error => {
        this.navigateToEmail(true);
      });
  }

  navigateToEmail(errorResponse) {
    this.setState({
      isLoaded: true
    });

    this.props.history.push({
      pathname: "/email",
      state: {
        "error": errorResponse
      }
    });
  }

  searchAgain() {
    this.props.history.push("/search");
  }

  render() {
    const files = this.props.location.state.files;
    const isLoaded = this.state.isLoaded;
    return (
      <>
        <div className="g-flex-col-sm-12">
          <div className="lui-text-content-area">
            <h2 className="demo-type">ELFI (Electronic LINZ File Index)</h2>
            <p>You have requested the following files. Fill in your details then click the "Confirm request" button to continue.</p>
            <div className="lui-divider lui-standard-form">
              <table className="lui-base-table lui-table-zebra">
                <thead>
                  <tr>
                    <th style={{"width": "250px"}}>File Number</th>
                    <th>Title</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    files.map(file => {
                      return (
                        <tr key={"tr-" + file.URI}>
                          <td className="lui-align-baseline">{file.FileNumber}</td>
                          <td>{file.Title}</td>
                        </tr>
                      )
                    })
                  }
                </tbody>
              </table>
            </div>
            <LuiFormikForm 
              initialValues={{}}
              onSubmit={this.handleSubmit.bind(this)}>
              <fieldset>
                <div className="lui-text-content-area">
                  <TextInput name="name" label="Name" value={this.state.name}
                    error={this.state.validationFailed.name} errorMessage="Please enter your name"
                    onChange={this.handleInputChange} />
                  <TextInput name="email" label="Email" value={this.state.email}
                    error={this.state.validationFailed.email} errorMessage="Please enter a valid email format"
                    onChange={this.handleInputChange} 
                  />
                </div>
                <div className="lui-text-content-area">
                  <p>
                    <LuiFormSubmitButton disabled={!isLoaded}>Confirm Request</LuiFormSubmitButton>
                    <LuiButton disabled={!isLoaded} onClick={() => this.searchAgain()}>Search Again</LuiButton>
                  </p>
                </div>
              </fieldset>
            </LuiFormikForm>
            {
              isLoaded ? null : (
                <div className="g-flex-container lui-margin-bottom-xxl">
                  <LuiLoadingSpinner />
                </div>
              )
            }
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(RequestFiles);
